var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotificationServices = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "notificationservices-a",
  points: "0 .307 14 .307 14 18 0 18"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 3)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.0049,11.6932 C16.6799,11.6932 16.3609,11.5352 16.1689,11.2432 C15.8649,10.7822 15.9919,10.1622 16.4539,9.8582 C17.4369,9.2112 17.9999,8.2402 17.9999,7.1942 C17.9999,6.1492 17.4369,5.1782 16.4539,4.5302 C15.9919,4.2272 15.8649,3.6072 16.1689,3.1452 C16.4739,2.6862 17.0939,2.5562 17.5539,2.8602 C19.0859,3.8692 19.9999,5.4892 19.9999,7.1942 C19.9999,8.8992 19.0859,10.5192 17.5539,11.5282 C17.3849,11.6402 17.1929,11.6932 17.0049,11.6932"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M14,5.7786 C14.583,5.9846 15,6.5406 15,7.1936 C15,7.8466 14.583,8.4016 14,8.6076"
}), /*#__PURE__*/React.createElement("mask", {
  id: "notificationservices-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#notificationservices-a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12,12.3149 L8.686,10.3339 C8.422,10.1429 8.115,10.0179 7.793,9.9719 L2,9.1439 L2,5.8439 L6.99,5.1409 L7,7.0049 C7.003,7.5559 7.45,7.9999 8,7.9999 L8.005,7.9999 C8.558,7.9969 9.003,7.5469 9,6.9949 L8.987,4.4849 L12,2.6819 L12,12.3149 Z M13.294,0.5289 C12.852,0.2539 12.308,0.2249 11.768,0.4939 L7.615,2.9749 L1.199,3.9399 C0.504,4.0799 0,4.6969 0,5.4049 L0,9.5809 C0,10.3129 0.523,10.9329 1.271,11.0599 L2.921,11.2959 L2.319,15.0899 C2.297,15.2239 2.286,15.3599 2.286,15.4999 C2.286,16.8779 3.407,17.9999 4.786,17.9999 L6.819,17.9999 L7.577,13.2159 L5.725,12.9699 L5.181,15.9999 L4.786,15.9999 C4.511,15.9999 4.245,15.7729 4.286,15.4999 L4.904,11.5799 L7.512,11.9539 L11.768,14.5059 L11.841,14.5449 C12.051,14.6479 12.276,14.6999 12.501,14.6999 C12.776,14.6999 13.051,14.6229 13.294,14.4709 C13.736,14.1949 14,13.7189 14,13.1979 L14,1.8019 C14,1.2809 13.736,0.8049 13.294,0.5289 L13.294,0.5289 Z",
  mask: "url(#notificationservices-b)"
}))));
export default SvgNotificationServices;